import { render, staticRenderFns } from "./TxProductBorder.vue?vue&type=template&id=57b876c9&scoped=true&"
import script from "./TxProductBorder.vue?vue&type=script&lang=js&"
export * from "./TxProductBorder.vue?vue&type=script&lang=js&"
import style0 from "./TxProductBorder.vue?vue&type=style&index=0&id=57b876c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b876c9",
  null
  
)

export default component.exports